import React, { useEffect } from 'react';
import { initMetaPixel, META_PIXEL_ID } from './lib/metaPixel';
import { Hero } from './components/Hero';
import { ProfessionalAudience } from './components/ProfessionalAudience';
import { StatsBar } from './components/StatsBar';
import { TestimonialStrip } from './components/TestimonialStrip';
import { Problems } from './components/Problems';
import { Modules } from './components/Modules';
import { ModuleIncludes } from './components/ModuleIncludes';
import { Comparison } from './components/Comparison';
import { Bonuses } from './components/Bonuses';
import { PricingPack } from './components/PricingPack';
import { Guarantee } from './components/Guarantee';
import { Reviews } from './components/Reviews';
import { CostOfNotBuying } from './components/CostOfNotBuying';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <main className="w-full overflow-x-hidden bg-mist font-sans text-navy antialiased" data-id="element-0" data-mp="3ikh5c1uvgeva">
      <noscript data-id="element-1" data-mp="3mlat8v8bdto6">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" data-mp="3mkrcviybbdc9" />
      </noscript>
      <Hero data-id="element-3" data-mp="5gfrc0u9uwx" />
      <ProfessionalAudience data-id="element-4" data-mp="56lhc8rh1lf" />
      <StatsBar data-id="element-5" data-mp="2zl3cxocsjc6w" />
      <TestimonialStrip data-id="element-6" data-mp="2zlld2w2kqak3" />
      <Problems data-id="element-7" data-mp="2zmeo498kfm81" />
      <Modules data-id="element-8" data-mp="2zmwit1fkxsdu" />
      <ModuleIncludes data-id="element-9" data-mp="2zng14j956ise" />
      <Comparison data-id="element-10" data-mp="33mf0loc3tncg" />
      <Bonuses data-id="element-11" data-mp="33lx0ggmbmoz9" />
      <PricingPack data-id="element-12" data-mp="33nggq77z9011" />
      <Guarantee data-id="element-13" data-mp="33mylndx1wrup" />
      <Reviews data-id="element-14" data-mp="33oi152avuyvf" />
      <CostOfNotBuying data-id="element-15" data-mp="38m1e7yvuh5ls" />
      <FAQ data-id="element-16" data-mp="38kqd66tsabyd" />
      <FinalCTA data-id="element-17" data-mp="38l05i12awv78" />
      <Footer data-id="element-18" data-mp="38kgmsi4tu2s5" />
    </main>;
}